<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('menu.editCompetitor') }}</h5>
                <div class="p-field p-grid" v-show="this.isEdit()">
                    <label for="sportId" class="p-col-12 p-mb-2 p-md-1 p-mb-md-0">{{ $t('sportsSettings.id') }}</label>
                    <div class="p-col-12 p-md-2">
                        <InputText style="width: 100%" id="sportId" type="text" v-model="competitor.competitorId" disabled />
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="sportName" class="p-col-12 p-mb-2 p-md-1 p-mb-md-0">{{ $t('sportsSettings.name') }} *</label>
                    <div class="p-col-12 p-md-2">
                        <InputText style="width: 100%" id="sportName" type="text" v-model="competitor.name" />
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="displayName" class="p-col-12 p-mb-2 p-md-1 p-mb-md-0">{{ $t('sportsSettings.displayName') }} *</label>
                    <div class="p-col-12 p-md-2">
                        <InputText style="width: 100%" id="displayName" type="text" v-model="competitor.displayName" />
                    </div>
                </div>
                <div class="p-field p-grid">
                    <div class="p-col-12">
                        <p>{{ $t('forms.mandatoryFieldsText') }}</p>
                    </div>
                </div>
                <transition-group name="p-message" tag="div">
                    <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ errorText }}</Message>
                </transition-group>
                <Button @click="submitForm()" :label="$t('buttons.save')" class="p-button-raised p-button-success p-mr-2 p-mb-2" />
                <Button :label="$t('buttons.cancel')" class="p-button-raised p-button-danger p-mr-2 p-mb-2" @click="goto(backRoute)" />
            </div>
        </div>
    </div>
</template>
<script>
import { SportsSettingsApi } from '../../service/SportSettingsApi';
export default {
    data() {
        return {
            SportsSettingsApi: new SportsSettingsApi(),
            competitor: {},
            showError: false,
            errorText: '',
            disableSubmit: false,
            backRoute: 'competitors',
            errorKeyCount: 0,
        };
    },
    mounted() {
        if (this.isEdit()) {
            this.SportsSettingsApi.getCompetitor(this.$route.params.id)
                .then((response) => {
                    this.competitor = response.data;
                })
                .catch((error) => {
                    this.errorText = error;
                    this.showError = true;
                    this.errorKeyCount++;
                });
        }
    },
    methods: {
        submitForm() {
            this.showError = false;
            this.errorText = '';
            this.disableSubmit = true;
            if (this.notNullOrEmptyObject(this.competitor) && this.notNullOrEmptyField(this.competitor.name) && this.notNullOrEmptyField(this.competitor.displayName)) {
                this.SportsSettingsApi.updateCompetitor(this.competitor)
                    .then(() => {
                        this.goto(this.backRoute);
                    })
                    .catch((error) => {
                        this.disableSubmit = false;
                        this.errorText = error;
                        this.showError = true;
                    });
            } else {
                this.errorText = this.$t('forms.mandatoryFieldsMessage');
                this.showError = true;
                this.disableSubmit = false;
                this.errorKeyCount++;
            }
        },
        isEdit() {
            return this.$route.params.id !== '0';
        },
    },
};
</script>
